import React from "react";
export const CallCalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <circle cx="18" cy="18" r="18" fill="#245cea" />
      <path
        d="M11.7758 10.7455C11.842 10.6793 11.8751 10.6462 11.9043 10.6194C12.6217 9.96022 13.7243 9.96022 14.4416 10.6194C14.4708 10.6462 14.5039 10.6793 14.5701 10.7455L15.9372 12.1126C16.6891 12.8645 16.9041 14 16.4792 14.9748C16.0543 15.9496 16.2694 17.0852 17.0213 17.8371L19.2683 20.0841C20.0202 20.836 21.1558 21.0511 22.1306 20.6262C23.1054 20.2012 24.2409 20.4163 24.9928 21.1682L26.3599 22.5353C26.4261 22.6015 26.4592 22.6346 26.486 22.6638C27.1452 23.3811 27.1452 24.4837 26.486 25.2011C26.4592 25.2302 26.4261 25.2634 26.3599 25.3296L25.5289 26.1605C24.8523 26.8372 23.8768 27.1213 22.9426 26.9137C16.5773 25.4992 11.6062 20.5281 10.1917 14.1628C9.98411 13.2286 10.2682 12.2531 10.9449 11.5765L11.7758 10.7455Z"
        fill="white"
      />
    </svg>
  );
};
